export default({titleModel, options, message, info, useNewPopover}) => `
    <div class="messageContainer">
        <div class="message">
            ${message}
            ${options.isLuckyDay && !titleModel.get('isOnHold')
                ? useNewPopover
                    ? `<div style="display: inline-block; position: relative">
                            <div style="display: inline-block; float: right">
                                <a role="button" id="luckyDayTooltip" class="help-tip secondary-background" style="float: right"></a>
                            </div>
                        </div>
                    `
                    : `<div style="display: inline-block; position: relative">
                        <div style="display: inline-block; float: right">
                            <a role="button" data-dropdown="luckyDay-help-tip" aria-controls="luckyDay-help-tip" tabindex="0" class="help-tip secondary-background luckyDay-help-tip" style="float: right"></a>
                        </div>
                    </div>
                    <div id="luckyDay-help-tip" data-dropdown-content class="f-dropdown medium content" aria-hidden="true" tabindex="-1">
                        <p>${info}</p>
                    </div>`
                : '' }
            ${titleModel.get('isOnHold') ? `
                <p class="stillOnHoldMessage">${window.html('nonHoldConflictModal.stillOnHold', {title: titleModel.title})}</p>
            ` : ''}
        </div>
    </div>
    <div class="relatedTitlesContainer">
        <div class="loader"></div>
    </div>
`;
